import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { verifyEmail } from '../actions/authActions';

export default function VerifyEmail() {
  const { token } = useParams();
  const dispatch = useDispatch();
  const [state, setState] = useState({ kind: 'loading', text: 'Verifying…' });
  useEffect(() => {
    (async () => {
      const res = await dispatch(verifyEmail(token));
      setState(res.ok
        ? { kind: 'success', text: 'Your email is verified. You can close this tab.' }
        : { kind: 'error',   text: res.error || 'Verification failed.' });
    })();
  }, [dispatch, token]);
  return (
    <section className="section narrow">
      <h1>Email verification</h1>
      <p className={`status ${state.kind === 'loading' ? '' : state.kind}`}>{state.text}</p>
      <p className="muted"><Link to="/dashboard">Go to dashboard</Link></p>
    </section>
  );
}
